var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTipIconAsset = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#91A2AE",
  d: "M5.412 7.765h1.176V8.94H5.412V7.765Zm0-4.706h1.176v4H5.412v-4ZM6 12a5.96 5.96 0 0 1-4.243-1.757A5.96 5.96 0 0 1 0 6c0-3.308 2.692-6 6-6 1.603 0 3.11.624 4.243 1.757A5.963 5.963 0 0 1 12 6c0 3.308-2.692 6-6 6Zm3.444-9.443A4.836 4.836 0 0 0 6 1.13H6a4.875 4.875 0 0 0-4.501 6.733 4.839 4.839 0 0 0 1.057 1.58A4.839 4.839 0 0 0 6 10.868a4.875 4.875 0 0 0 4.501-6.733 4.84 4.84 0 0 0-1.057-1.58Z"
})));
export default SvgTipIconAsset;